import React from 'react';
import { LazySection } from './LazySection';
export function Mecanismo() {
  return <LazySection className="bg-ink text-cream !pt-[80px] !pb-[100px] md:!pt-[100px] md:!pb-[120px]" data-id="element-197">
      <div className="container-wide" data-id="element-198">
        <div className="text-center" data-id="element-199">
          <span className="eyebrow !text-gold-light" data-id="element-200">
            El origen de tus bloqueos
          </span>
        </div>
        <h2 className="text-[clamp(34px,5vw,54px)] mb-6 text-center text-cream" data-id="element-201">
          Mucho de lo que sentís{' '}
          <em className="text-gold-light" data-id="element-202">ni siquiera empezó con vos</em>.
        </h2>
        <p className="text-center text-lg text-cream/80 max-w-[720px] mx-auto mb-[60px]" data-id="element-203">
          Lo que tu terapia trabajó como síntoma tuyo, este sistema lo trabaja
          como herencia trazable. Esa es la diferencia.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-[30px] relative mb-[60px]" data-id="element-204">
          {/* Line connector for desktop */}
          <div className="hidden md:block absolute top-[30px] left-[8%] right-[8%] h-[1px] bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-205" />

          <div className="text-center relative" data-id="element-206">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-207" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-208">
              Hace 3 generaciones
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-209">
              Bisabuelos
            </div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-210">
              El evento que nadie pudo procesar. Lo que ahí no se elaboró queda
              inscripto como información en el sistema.
            </p>
          </div>

          <div className="text-center relative" data-id="element-211">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-212" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-213">
              Hace 2 generaciones
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-214">
              Abuelos
            </div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-215">
              Lo callaron. Lo enterraron en silencio. Pero el silencio no borra
              — solo desplaza.
            </p>
          </div>

          <div className="text-center relative" data-id="element-216">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-217" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-218">
              Hace 1 generación
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-219">Padres</div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-220">
              Lo recibieron sin saberlo, y te lo transmitieron del mismo modo —
              en gestos, en miradas, en lo no dicho.
            </p>
          </div>

          <div className="text-center relative" data-id="element-221">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-222" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-223">
              Hoy
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-224">Vos</div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-225">
              Lo estás sintiendo como tuyo — porque nadie te dio el mapa para
              ver de dónde viene.
            </p>
          </div>
        </div>

        <div className="bg-gold/10 border border-gold/25 rounded-[20px] p-8 md:px-10 md:py-11 text-center max-w-[780px] mx-auto mb-[60px]" data-id="element-226">
          <h3 className="text-[clamp(24px,3.5vw,32px)] mb-[18px] leading-[1.25] text-cream" data-id="element-227">
            Eso que tu terapia no terminó de explicarte tiene un nombre:{' '}
            <span className="bg-gradient-to-br from-gold/25 to-gold/25 px-2 py-0.5 rounded italic text-[#f5d9a8]" data-id="element-228">
              <span className="highlight-keyword-light" data-id="element-229">lealtad</span> familiar
              inconsciente
            </span>
            .
          </h3>
          <p className="text-cream/85 text-base max-w-[620px] mx-auto" data-id="element-230">
            Tu sistema nervioso aprendió de tu familia qué emociones eran
            "seguras", qué nivel de felicidad era "permitido", qué tipo de
            relaciones eran "normales". Y los repite en automático — aunque tu
            mente adulta quiera otra cosa.
          </p>
        </div>

        <div className="max-w-[900px] mx-auto" data-id="element-231">
          <h3 className="text-center text-[clamp(22px,3vw,28px)] mb-[30px] text-gold-light" data-id="element-232">
            No es espiritualidad.{' '}
            <em className="text-cream not-italic" data-id="element-233">Es ciencia publicada.</em>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-234">
            <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-235">
              <div className="font-serif text-gold-light text-xs tracking-[0.05em] mb-2.5 font-medium" data-id="element-236">
                Universidad de Emory · 2013
              </div>
              <h4 className="text-cream text-base mb-2.5 font-medium" data-id="element-237">
                Los miedos se heredan entre generaciones
              </h4>
              <p className="text-[13px] text-cream/70 leading-[1.55]" data-id="element-238">
                Brian Dias demostró que los miedos aprendidos por una generación
                se transmiten epigenéticamente a la siguiente — sin que la nueva
                generación los haya vivido.
              </p>
            </div>

            <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-239">
              <div className="font-serif text-gold-light text-xs tracking-[0.05em] mb-2.5 font-medium" data-id="element-240">
                Mount Sinai Hospital · 2015
              </div>
              <h4 className="text-cream text-base mb-2.5 font-medium" data-id="element-241">
                El trauma deja marcas biológicas heredables
              </h4>
              <p className="text-[13px] text-cream/70 leading-[1.55]" data-id="element-242">
                Rachel Yehuda documentó alteraciones epigenéticas en hijos de
                sobrevivientes del Holocausto — publicado en{' '}
                <em className="text-gold-light" data-id="element-243">Biological Psychiatry</em>.
              </p>
            </div>

            <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-244">
              <div className="font-serif text-gold-light text-xs tracking-[0.05em] mb-2.5 font-medium" data-id="element-245">
                Psicología transgeneracional
              </div>
              <h4 className="text-cream text-base mb-2.5 font-medium" data-id="element-246">
                El origen familiar se puede mapear
              </h4>
              <p className="text-[13px] text-cream/70 leading-[1.55]" data-id="element-247">
                Schützenberger, Hellinger y Lipton: trazar el{' '}
                <span className="highlight-keyword-light" data-id="element-248">origen</span> familiar
                de un patrón es el primer paso real para interrumpirlo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </LazySection>;
}